var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Navbar', {
    attrs: {
      "nav-light": true
    }
  }), _c('section', {
    staticClass: "bg-half bg-primary d-table w-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('div', {
    staticClass: "page-next-level"
  }, [_c('h4', {
    staticClass: "title text-white"
  }, [_vm._v(_vm._s(_vm.$t("business-partner")))])])])])])]), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 mt-4 pt-2"
  }, [_vm.error == 1 ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(" " + _vm._s(_vm.$t("list-business-partners")) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 offset-md-3 mt-4 pt-2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'organization.list',
        params: {
          type: 'Individu'
        }
      }
    }
  }, [_c('div', {
    staticClass: "card rounded shadow bg-dark border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.$t("individual")))]), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "h6 text-muted mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("business-partner-type-info")) + " ")])])]), _c('button', {
    staticClass: "btn btn-primary btn-sm"
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/next.png",
      "height": "30",
      "alt": ""
    }
  })])])])])])], 1), _c('div', {
    staticClass: "col-md-6 offset-md-3 mt-4 pt-2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'organization.list',
        params: {
          type: 'Bank'
        }
      }
    }
  }, [_c('div', {
    staticClass: "card rounded shadow bg-dark border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v("Bank")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "h6 text-muted mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("business-partner-type-info")) + " ")])])]), _c('button', {
    staticClass: "btn btn-primary btn-sm"
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/next.png",
      "height": "30",
      "alt": ""
    }
  })])])])])])], 1), _c('div', {
    staticClass: "col-md-6 offset-md-3 mt-4 pt-2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'organization.list',
        params: {
          type: 'Koperasi'
        }
      }
    }
  }, [_c('div', {
    staticClass: "card rounded shadow bg-dark border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.$t("cooperative")))]), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "h6 text-muted mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("business-partner-type-info")) + " ")])])]), _c('button', {
    staticClass: "btn btn-primary btn-sm"
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/next.png",
      "height": "30",
      "alt": ""
    }
  })])])])])])], 1), _c('div', {
    staticClass: "col-md-6 offset-md-3 mt-4 pt-2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'organization.list',
        params: {
          type: 'Swasta'
        }
      }
    }
  }, [_c('div', {
    staticClass: "card rounded shadow bg-dark border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.$t("private-org")))]), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "h6 text-muted mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("business-partner-type-info")) + " ")])])]), _c('button', {
    staticClass: "btn btn-primary btn-sm"
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/next.png",
      "height": "30",
      "alt": ""
    }
  })])])])])])], 1), _c('div', {
    staticClass: "col-md-6 offset-md-3 mt-4 pt-2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'organization.list',
        params: {
          type: 'Kerajaan'
        }
      }
    }
  }, [_c('div', {
    staticClass: "card rounded shadow bg-dark border-0"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v(_vm._s(_vm.$t("glc")))]), _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "h6 text-muted mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("business-partner-type-info")) + " ")])])]), _c('button', {
    staticClass: "btn btn-primary btn-sm"
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/next.png",
      "height": "30",
      "alt": ""
    }
  })])])])])])], 1)])])]), _c('Footer'), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: '#topnav',
      expression: "'#topnav'"
    }],
    staticClass: "btn btn-icon btn-soft-primary back-to-top",
    attrs: {
      "href": "javascript: void(0);",
      "id": "back-to-top"
    }
  }, [_c('arrow-up-icon', {
    staticClass: "icons"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }